import useWindowSize from "../../../../hooks/useWindowSize";
import { func } from "../../../../utils";
import { ContainerWidth, SectionContainer, GallerySectionContainer } from "./GallerySoc.styled";
import HomeGalleryCard from "../../../../pages/v2/HomeDetails/GalleryCard";
import Section from "../../../atoms/Section";

const imgPath = `${process.env.REACT_APP_API_HOST}/uploads/featured-images/`;

const GallerySoc = ({ dataGallery = [] }) => {
  const { size } = useWindowSize();
  const isMobileView = (size?.width || 0) <= 830;

  return (
    <div className="relative">
      <img
        className="absolute left-0 top-0 z-[1] w-[100%]"
        src={func.getStaticImg(
          isMobileView
            ? "illustration/gallerysoc-swoosh-bg-m.svg"
            : "illustration/gallerysoc-swoosh-bg.svg",
        )}
      />
      <div className="relative flex flex-col justify-between h-screen w-full z-[2] p-[24px]">
        <div className="flex flex-col max-w-[1016px] mx-auto mt-48 md:my-auto">
          {isMobileView ? (
            <h5
              style={{
                width: "100%",
                textAlign: "left",
                margin: "0",
                color: "white",
                fontSize: 20,
                fontWeight: "bold",
              }}
            >
              Gallery
            </h5>
          ) : (
            <h1
              style={{
                width: "100%",
                textAlign: "left",
                margin: "0",
                color: "white",
                fontSize: 40,
                fontWeight: "bold",
              }}
            >
              Gallery
            </h1>
          )}
          <GallerySectionContainer style={isMobileView ? { justifyContent: "center" } : {}}>
            {dataGallery?.map((value, idx) => (
              <HomeGalleryCard
                key={idx}
                title={value?.title}
                imgSrc={
                  isMobileView ? imgPath + value?.key_visual_mobile : imgPath + value?.key_visual
                }
                onClick={() => window.open(value?.drive_url)}
              />
            ))}
          </GallerySectionContainer>
        </div>
      </div>
    </div>
  );
};
export default GallerySoc;
